import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('#success-stories')]
	els.map(el => {

		const carouselEl = el.querySelector('.success-carousel')
		if (!carouselEl) return null


		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1,
			touch: true,
			nav: false,
			controls : true,
			mouseDrag: true,
			loop: true,
			center: true,
			slideby: 1,
			responsive : {
				450 : { items : 1, center: false },
				608 : { items : 1, center: false },
				880 : { items : 3, center: false },
			}
		})
	})
}


